<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon"></app-page-title>
<div *ngIf="!usersService.hasGlobalSectionRight('Admin')">
    You have no rights to access this page
</div>
<div *ngIf="locked && usersService.hasGlobalSectionRight('Admin')">
    A Groups Share maintenance process is currently in progress.
    Please try again later or wait for the process to finish.
</div>
<div *ngIf="loadFinished && usersService.hasGlobalSectionRight('Admin')">
    <div class="main-card mb-3 card mt-4">
        <div class="card-body">
            <div class="row align-items-center mb-4">
                <div class="col">
                    <h2 class="mb-0">Groups Share</h2>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn-wide mb-2 mr-2 btn btn-primary btn-lg" (click)="createGroupShare()">
                        <i class="fa fa-plus mr-1"></i>
                        New Group
                    </button>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <eris-table [dataSource]="groupsDataSource" #groupsTable>
                        <tr *ngIf="!groupsTable.data || groupsTable.data.length === 0">
                            <td colspan="6" class="text-center text-muted py-4">
                                No groups found
                            </td>
                        </tr>
                        <ng-container *ngFor="let group of groupsTable.data">
                            <tr
                                class="group-row"
                                [class.group-row-expanded]="isGroupExpanded(group.id)"
                                [attr.aria-expanded]="isGroupExpanded(group.id)"
                                role="button"
                                tabindex="0"
                                (click)="toggleGroup(group.id)"
                                (keydown.enter)="toggleGroup(group.id)"
                                (keydown.space)="toggleGroup(group.id); $event.preventDefault()">
                                <th scope="row" class="align-middle group-column-id">
                                    <i class="fa mr-2" [ngClass]="isGroupExpanded(group.id) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                    {{ group.id }}
                                </th>
                                <td class="align-middle group-column-name group-name-cell" [title]="group.name">{{ group.name }}</td>
                                <td class="align-middle text-center group-column-businesses">{{ group.businessesCount }}</td>
                                <td class="align-middle text-center group-column-advertisers">{{ group.elementsCount }}</td>
                                <td class="align-middle group-column-platform">
                                    <div class="group-platform">
                                        <img [src]="getPlatformIcon(group.targetPlatform)" [alt]="getPlatformName(group.targetPlatform)" class="group-platform-icon">
                                        <span class="group-platform-name" [title]="getPlatformName(group.targetPlatform)">
                                            {{ getPlatformName(group.targetPlatform) }}
                                        </span>
                                    </div>
                                </td>
                                <td class="align-middle text-center group-column-actions">
                                    <button type="button" class="btn btn-primary btn-sm mr-2" title="Edit group" (click)="$event.stopPropagation(); editGroupShare(group)">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger btn-sm" title="Delete group" (click)="$event.stopPropagation(); deleteGroup(group)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr class="group-detail-row">
                                <td colspan="6" class="group-detail-cell">
                                    <div [ngbCollapse]="!isGroupExpanded(group.id)" class="group-detail-content">
                                        <div class="p-3">
                                            <div class="table-responsive">
                                                <table
                                                    class="table table-sm table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 30%">Business ID</th>
                                                            <th style="width: 50%">Business name</th>
                                                            <th class="text-center" style="width: 20%">Advertisers</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container *ngFor="let business of group.businesses">
                                                            <tr
                                                                class="business-row"
                                                                [class.business-row-expanded]="isBusinessExpanded(group.id,business.id)"
                                                                [attr.aria-expanded]="isBusinessExpanded(group.id,business.id)"
                                                                role="button"
                                                                tabindex="0"
                                                                (click)="toggleBusiness(group.id,business.id)"
                                                                (keydown.enter)="toggleBusiness(group.id,business.id)"
                                                                (keydown.space)="toggleBusiness(group.id,business.id);$event.preventDefault()">
                                                                <th scope="row" class="align-middle" style="word-break: break-word">
                                                                    <i class="fa mr-2"
                                                                        [ngClass]="isBusinessExpanded(group.id,business.id) ? 'fa-chevron-down' : 'fa-chevron-right'">
                                                                    </i>
                                                                    {{ business.id }}
                                                                </th>
                                                                <td class="align-middle" [title]="business.name">{{ business.name }}</td>
                                                                <td class="align-middle text-center">{{ business.items?.length || 0 }}</td>
                                                            </tr>
                                                            <tr class="business-detail-row">
                                                                <td colspan="3" class="business-detail-cell">
                                                                    <div [ngbCollapse]="!isBusinessExpanded(group.id,business.id)" class="business-detail-content">
                                                                        <div class="p-3">
                                                                            <div class="table-responsive">
                                                                                <table class="table table-sm table-bordered mb-0">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th style="width: 35%">Advertiser ID</th>
                                                                                            <th style="width: 65%">Advertiser name</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr *ngFor="let item of business.items">
                                                                                            <td class="align-middle" [title]="item.id">{{ item.id }}</td>
                                                                                            <td class="align-middle" [title]="item.name">{{ item.name }}</td>
                                                                                        </tr>
                                                                                        <tr *ngIf="!business.items || business.items.length === 0">
                                                                                            <td colspan="2" class="text-center text-muted py-3">
                                                                                                No advertisers in this business
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                        <tr *ngIf="!group.businesses || group.businesses.length === 0">
                                                            <td colspan="3" class="text-center text-muted py-3">
                                                                No businesses in this group
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </eris-table>
                </div>
            </div>
        </div>
    </div>
</div>